import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, BackTop, Button, Breadcrumb } from 'antd';
import { DoubleRightOutlined, DownloadOutlined, PlusOutlined } from '@ant-design/icons';
import { TableList } from 'components/list';
import AuthRedirect from 'components/AuthRedirect';
import ModalFilter from '../modal/Filter';
import ModalDelete from '../modal/Delete';
import SearchTable from 'components/search-table/SearchTable';
import { PageHeader } from 'components/header';
import { SortingTableWithFilter } from 'components/sorting-table';
import columns from './Columns';
import useList from '../hooks/useList';
import { withRouter } from "react-router-dom";
import ModalExport from '../modal/Export';

const sortFields = [{
  value: "id",
  label: "Tanggal Pembuatan",
},{
  value: "nama",
  label: "Nama Rombel",
},{
  value: "tingkatan_kelas",
  label: "Tingkat Kelas",
},{
  value: "total_siswa",
  label: "Total Siswa",
}];

const RombonganBelajar = ({ history, privilege }) => {
  const {
    table,
    filter,
    deleteState,
    exportState,
    fetchTable,
    fetchData,
    setTempTableFilter,
    setTableFilterFromTemp,
    modalFilter,
    modalDelete,
    modalExport,
    onCopy
  } = useList(privilege?.tahun_ajaran, privilege?.semester);

  const access = privilege.access["/kurikulum/rombel"];
  if (!access) return <AuthRedirect />;
  const action = access.action;

  return (
    <>
      <PageHeader
        style={{
          padding: 0
        }}
        onBack={() => window.history.back()}
        title={<Breadcrumb style={{ margin: '16px 0' }} separator={<DoubleRightOutlined />}>
          <Breadcrumb.Item>Kurikulum</Breadcrumb.Item>
          <Breadcrumb.Item>Rombongan Belajar </Breadcrumb.Item>
        </Breadcrumb>}
      />
      <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
        <PageHeader
          className="site-page-header"
          title="Rombongan Belajar"
          subTitle="Data rombongan belajar"
          extra={[
            action.export && (
              <Button
                onClick={() => {
                  modalExport(true);
                }}
                icon={<DownloadOutlined />}>
                Export
              </Button>
            ),
            privilege?.semester?.tipe_semester === "Genap" && (
                <Button
                  onClick={onCopy}
                  icon={<DownloadOutlined />}>
                  Copy data semester
                </Button>
              ),
            action.create && (
              <Button
                type='primary'
                onClick={() => {
                  history.push("/kurikulum/rombel/create");
                }}
                icon={<PlusOutlined />}>
                Tambah
              </Button>
            ),
          ]} />
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={18} md={19}>
            <SearchTable table={table} fetch={fetchData} />
          </Col>
          <Col xs={24} sm={6} md={5}>
            <SortingTableWithFilter
              table={table}
              fetch={fetchData}
              modalFilter={modalFilter}
              sortFields={sortFields}
            />
          </Col>
          <Col xs={24}>
            <TableList
              state={{ table, filter }}
              fetch={fetchData}
              fetchTable={fetchTable}
              columns={columns(action, null, modalDelete)}
            />
          </Col>
        </Row>
      </div>

      {filter.visible && (
        <ModalFilter
          values={filter.values}
          visible={filter.visible}
          hideModal={() => modalFilter(false)}
          setTempTableFilter={setTempTableFilter}
          setTableFilterFromTemp={setTableFilterFromTemp}
        />
      )}
      {deleteState.visible && (
        <ModalDelete
          data={deleteState.data}
          visible={deleteState.visible}
          hideModal={() => modalDelete(false)}
          fetchTable={fetchTable}
        />
      )}
      {exportState.visible && (
        <ModalExport
          data={exportState.data}
          visible={exportState.visible}
          hideModal={() => modalExport(false)}
        />
      )}
      <BackTop />
    </>

  );
};

const mapStateToProps = (state) => ({
  privilege: state.privilege,
});

export default connect(mapStateToProps)(withRouter(RombonganBelajar));